<div
    class="fc-order-matrix-wrapper-scroll-icon fc-order-matrix-wrapper-scroll-icon-left fa fa-angle-left pointer"
    [ngStyle]="{
        left: scrollIconStylePx[Direction.Left].left + 'px',
        top: scrollIconStylePx[Direction.Left].top + 'px'
    }"
    *ngIf="isScrollIconVisible[Direction.Left]"
    (click)="scrollMatrix(Direction.Left)"
></div>
<div
    class="fc-order-matrix-wrapper-scroll-icon fa fa-angle-right pointer"
    [ngStyle]="{
        right: scrollIconStylePx[Direction.Right].right + 'px',
        top: scrollIconStylePx[Direction.Right].top + 'px'
    }"
    *ngIf="isScrollIconVisible[Direction.Right]"
    (click)="scrollMatrix(Direction.Right)"
>
    <div class="fc-order-matrix-wrapper-scroll-icon-right"></div>
</div>

<ng-container *ngIf="useGroupedHeaders; else originalHeaders">
    @if (invertGroupedHeaders) {
        <ng-container *ngTemplateOutlet="childHeaders"></ng-container>
        <ng-container *ngTemplateOutlet="parentHeaders"></ng-container>
    } @else {
        <ng-container *ngTemplateOutlet="parentHeaders"></ng-container>
        <ng-container *ngTemplateOutlet="childHeaders"></ng-container>
    }
</ng-container>

<ng-template #parentHeaders>
    <tr
        class="fc-order-matrix-headers-row grouped-headers parent-headers"
        [ngClass]="{ 'use-sticky-header': useStickyHeader }"
    >
        <!-- Parent headers (Waist sizes) -->
        <th class="fc-order-matrix-headers-row-header first-row-header" *ngIf="!hideFirstCell"></th>
        <th
            *ngFor="let group of groupedHeaders; let groupIndex = index"
            [attr.colspan]="group.childLabels.length"
            class="fc-order-matrix-headers-row-header parent-header"
        >
            {{ group.parentPrefix }}{{ group.parentLabel }}
        </th>
    </tr>
</ng-template>

<ng-template #childHeaders>
    <tr
        class="fc-order-matrix-headers-row grouped-headers child-headers"
        [ngClass]="{ 'use-sticky-header': useStickyHeader }"
    >
        <!-- Child headers (Length sizes) -->
        <th class="fc-order-matrix-headers-row-header" *ngIf="!hideFirstCell"></th>
        <ng-container *ngFor="let group of groupedHeaders; let groupIndex = index">
            <th
                *ngFor="let childLabel of group.childLabels; let childIndex = index"
                [ngClass]="{
                    'fc-order-matrix-headers-row-header': true,
                    'child-header': true,
                    'fc-order-matrix-header-clickable': enableHoverAndCopy,
                    'last-child-header': childIndex === group.childLabels.length - 1
                }"
                (mouseenter)="
                    enableHoverAndCopy && toggleEanDisplay(true, 'grouped-header-' + groupIndex + '-' + childIndex)
                "
                (mouseleave)="
                    enableHoverAndCopy && toggleEanDisplay(false, 'grouped-header-' + groupIndex + '-' + childIndex)
                "
                (click)="
                    enableHoverAndCopy && copyHeaderText('grouped-header-' + groupIndex + '-' + childIndex, $event)
                "
            >
                <span
                    [ngClass]="{
                        'fc-order-matrix-header-hover-text':
                            enableHoverAndCopy &&
                            isHeaderHovered('grouped-header-' + groupIndex + '-' + childIndex) &&
                            hasEanMapping('grouped-header-' + groupIndex + '-' + childIndex)
                    }"
                >
                    {{
                        getHeaderDisplayText(
                            'grouped-header-' + groupIndex + '-' + childIndex,
                            group.childPrefix + childLabel
                        )
                    }}
                </span>
            </th>
        </ng-container>
    </tr>
</ng-template>

<ng-template #originalHeaders>
    <tr class="fc-order-matrix-headers-row" [ngClass]="{ 'use-sticky-header': useStickyHeader }">
        <ng-container *ngIf="!(hideFirstCell && i === 0)">
            <th
                [ngClass]="{
                    'fc-order-matrix-headers-row-header-black': type === MatrixType.Compound,
                    'fc-order-matrix-headers-row-header-max-width': useTooltip,
                    'fc-order-matrix-headers-row-header-store-copy-clicked': displayCopyDropdown[i]
                }"
                class="fc-order-matrix-headers-row-header"
                *ngFor="let header of headers; let i = index"
            >
                <div *ngIf="useTooltip; else simpleText">
                    <div
                        cdkOverlayOrigin
                        #headerCell="cdkOverlayOrigin"
                        (mouseenter)="
                            enableHoverAndCopy && toggleEanDisplay(true, 'standard-header-' + i); toggleTooltip(true, i)
                        "
                        (mouseleave)="
                            enableHoverAndCopy && toggleEanDisplay(false, 'standard-header-' + i);
                            toggleTooltip(false, i)
                        "
                        (click)="enableHoverAndCopy && copyHeaderText('standard-header-' + i, $event)"
                        [ngClass]="{
                            'fc-order-matrix-headers-row-store-text': !!headerStoreIds[i],
                            'fc-order-matrix-header-clickable': enableHoverAndCopy
                        }"
                    >
                        <fcp-icon *ngIf="isIcon(header)" [icon]="header.split(' ')"></fcp-icon>
                        <fcp-ellipsis-tooltip-text
                            *ngIf="!isIcon(header)"
                            [text]="
                                getHeaderDisplayText(
                                    'standard-header-' + i,
                                    capitalizeHeaders ? (header | uppercase) : header
                                )
                            "
                            [ngClass]="{
                                'fc-order-matrix-header-hover-text':
                                    enableHoverAndCopy &&
                                    isHeaderHovered('standard-header-' + i) &&
                                    hasEanMapping('standard-header-' + i)
                            }"
                        >
                        </fcp-ellipsis-tooltip-text>
                    </div>
                    <fcp-tooltip
                        *ngIf="tooltips[i]"
                        [open]="displayTooltip[i]"
                        [overlayOrigin]="headerCell"
                        [customPosition]="tooltipPosition"
                    >
                        <div>
                            {{ tooltips[i] | translate }}
                        </div>
                    </fcp-tooltip>

                    <div *ngIf="!!headerStoreIds[i] && showCopy">
                        <i
                            class="far fa-ellipsis-v fc-order-matrix-copy-icon"
                            (click)="showCopyDropdownMenu(i)"
                            id="copy-icon"
                        ></i>
                        <div
                            class="fc-order-matrix-copy-dropdown"
                            [ngClass]="{ 'copy-dropdown-display': displayCopyDropdown[i] }"
                            (click)="onCopyDropdownMenuClick(headerStoreIds[i], i)"
                        >
                            {{ 'ORDER.MATRIX.COPY_ALL_QUANTITIES' | translate }}
                        </div>
                    </div>
                </div>

                <ng-template #simpleText>
                    <div
                        (mouseenter)="enableHoverAndCopy && toggleEanDisplay(true, 'standard-header-' + i)"
                        (mouseleave)="enableHoverAndCopy && toggleEanDisplay(false, 'standard-header-' + i)"
                        (click)="enableHoverAndCopy && copyHeaderText('standard-header-' + i, $event)"
                        [ngClass]="{ 'fc-order-matrix-header-clickable': enableHoverAndCopy }"
                    >
                        <span
                            [ngClass]="{
                                'fc-order-matrix-header-hover-text':
                                    enableHoverAndCopy &&
                                    isHeaderHovered('standard-header-' + i) &&
                                    hasEanMapping('standard-header-' + i)
                            }"
                        >
                            {{
                                getHeaderDisplayText(
                                    'standard-header-' + i,
                                    capitalizeHeaders ? (header | uppercase) : header
                                )
                            }}
                        </span>
                    </div>
                </ng-template>
            </th>
        </ng-container>
    </tr>
</ng-template>
